import React, { useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Swiper as SwiperType } from 'swiper'
import 'swiper/css'
import { useRef } from 'react'

const NewsGalleryVideo = ({ isOpen, setIsOpen, list }) => {
    const swiperRef = useRef<SwiperType>()
    const videoRef = useRef<HTMLIFrameElement>(null)
    const arrowsRef = useRef<HTMLDivElement>(null)
    const [currentSlide, setCurrentSlide] = useState(1)

    // 

    React.useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (typeof list === 'string') {
                if (videoRef.current && !event.composedPath().includes(videoRef.current)) {
                    setIsOpen(false)
                }
            } else {
                if (
                    videoRef.current &&
                    arrowsRef.current &&
                    !event.composedPath().includes(videoRef.current) &&
                    !event.composedPath().includes(arrowsRef.current)
                ) {
                    setIsOpen(false)
                }
            }
        }

        document.body.addEventListener('click', handleClickOutside)
        return () => document.body.removeEventListener('click', handleClickOutside)
    }, [])

    return (
        <div
            className={`news-details__gallery-slider-wrapper ${isOpen && 'news-details__gallery-slider-wrapper_open'}`}
        >
            <div
                onClick={() => setIsOpen(false)}
                className='news-details__gallery-slider-close'
            >
                <svg
                    width='20'
                    height='20'
                    viewBox='0 0 20 20'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                >
                    <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M3.26231 3.2675C3.61407 2.91287 4.18671 2.91055 4.54134 3.26231L10.2301 8.90506L15.9188 3.26231C16.2735 2.91055 16.8461 2.91287 17.1979 3.2675C17.5496 3.62213 17.5473 4.19477 17.1927 4.54653L11.5143 10.1789L16.8319 15.4535C17.1865 15.8052 17.1888 16.3779 16.8371 16.7325C16.4853 17.0871 15.9127 17.0895 15.558 16.7377L10.2301 11.4528L4.90214 16.7377C4.54751 17.0895 3.97487 17.0871 3.62311 16.7325C3.27135 16.3779 3.27367 15.8052 3.6283 15.4535L8.94582 10.1789L3.2675 4.54653C2.91287 4.19477 2.91055 3.62213 3.26231 3.2675Z'
                        fill='#7987AC'
                    />
                </svg>
            </div>
            <Swiper
                className='news-details__gallery-slider container'
                slidesPerView={1}
                onBeforeInit={swiper => {
                    swiperRef.current = swiper
                }}
                onTransitionStart={() => setCurrentSlide(swiperRef.current?.activeIndex + 1)}
                centeredSlides={true}
                centeredSlidesBounds={true}
            >
                {list && list.length !== 0 ? (
                    typeof list === 'string' ? (
                        <SwiperSlide className='news-details__gallery-slide'>
                            <iframe
                                ref={videoRef}
                                width='100%'
                                height='596'
                                frameBorder={0}
                                src={list}
                            ></iframe>
                        </SwiperSlide>
                    ) : (
                        list?.map((video, i) => (
                            <SwiperSlide
                                className='news-details__gallery-slide'
                                key={i}
                            >
                                <iframe
                                    ref={videoRef}
                                    width='100%'
                                    height='596'
                                    frameBorder={0}
                                    src={video}
                                ></iframe>
                            </SwiperSlide>
                        ))
                    )
                ) : (
                    <div className='news-details__gallery-slide_empty'>Галерея пуста!</div>
                )}
            </Swiper>
            {list?.length !== 0 && typeof list !== 'string' && (
                <div className='news-details__nav-middle'>
                    <div
                        onClick={() => swiperRef.current.slidePrev()}
                        className='news-details__nav-btn news-details__nav-btn_prev'
                    >
                        <svg
                            width='20'
                            height='20'
                            viewBox='0 0 20 20'
                            fill='none'
                            xmlns='http://www.w3.org/2000/svg'
                        >
                            <path
                                d='M0.292893 9.29288C-0.0976311 9.6834 -0.0976311 10.3166 0.292893 10.7071L6.65685 17.0711C7.04738 17.4616 7.68054 17.4616 8.07107 17.0711C8.46159 16.6805 8.46159 16.0474 8.07107 15.6568L2.41421 9.99999L8.07107 4.34313C8.46159 3.95261 8.46159 3.31944 8.07107 2.92892C7.68054 2.53839 7.04738 2.53839 6.65685 2.92892L0.292893 9.29288ZM19 11C19.5523 11 20 10.5523 20 9.99999C20 9.4477 19.5523 8.99999 19 8.99999V11ZM1 11L19 11V8.99999L1 8.99999L1 11Z'
                                fill='#7987AC'
                            />
                        </svg>
                    </div>
                    <div
                        onClick={() => swiperRef.current.slideNext()}
                        className='news-details__nav-btn news-details__nav-btn_next'
                    >
                        <svg
                            style={{ transform: 'rotate(180deg)' }}
                            width='20'
                            height='20'
                            viewBox='0 0 20 20'
                            fill='none'
                            xmlns='http://www.w3.org/2000/svg'
                        >
                            <path
                                d='M0.292893 9.29288C-0.0976311 9.6834 -0.0976311 10.3166 0.292893 10.7071L6.65685 17.0711C7.04738 17.4616 7.68054 17.4616 8.07107 17.0711C8.46159 16.6805 8.46159 16.0474 8.07107 15.6568L2.41421 9.99999L8.07107 4.34313C8.46159 3.95261 8.46159 3.31944 8.07107 2.92892C7.68054 2.53839 7.04738 2.53839 6.65685 2.92892L0.292893 9.29288ZM19 11C19.5523 11 20 10.5523 20 9.99999C20 9.4477 19.5523 8.99999 19 8.99999V11ZM1 11L19 11V8.99999L1 8.99999L1 11Z'
                                fill='#7987AC'
                            />
                        </svg>
                    </div>
                </div>
            )}
            {list?.length !== 0 && typeof list !== 'string' && (
                <div className='news-details__nav-bottom'>
                    <div
                        onClick={() => swiperRef.current.slidePrev()}
                        className='news-details__nav-btn news-details__nav-btn_prev'
                    >
                        <svg
                            width='20'
                            height='20'
                            viewBox='0 0 20 20'
                            fill='none'
                            xmlns='http://www.w3.org/2000/svg'
                        >
                            <path
                                d='M12 6L8.05905 10.4336C8.02538 10.4715 8.02538 10.5285 8.05905 10.5664L12 15'
                                stroke='#A9B4D1'
                                strokeWidth='1.6'
                                strokeLinecap='round'
                            />
                        </svg>
                    </div>
                    <p>
                        {currentSlide}/{list?.length}
                    </p>
                    <div
                        onClick={() => swiperRef.current.slideNext()}
                        className='news-details__nav-btn news-details__nav-btn_next'
                    >
                        <svg
                            style={{ transform: 'rotate(180deg)' }}
                            width='20'
                            height='20'
                            viewBox='0 0 20 20'
                            fill='none'
                            xmlns='http://www.w3.org/2000/svg'
                        >
                            <path
                                d='M12 6L8.05905 10.4336C8.02538 10.4715 8.02538 10.5285 8.05905 10.5664L12 15'
                                stroke='#A9B4D1'
                                strokeWidth='1.6'
                                strokeLinecap='round'
                            />
                        </svg>
                    </div>
                </div>
            )}
        </div>
    )
}

export default NewsGalleryVideo
